module.exports = __webpack_public_path__ + "img/icon.946caad3.svg";